import React, { Component } from 'react';
import range from 'lodash/range';
import moment from 'moment';
import 'moment-timezone';
import PropTypes from 'prop-types';
import DataPopover from 'components/DataPopover';
import PostActions from 'components/FeedList/Post/PostActions';
import ProfileIcon from 'components/ProfileIcon';
import TimeSince from 'components/TimeSince';
import { fromIso9075DateString } from 'utils/dates';
import { userShape, wallPostShape } from 'utils/shapes';
import WindCreekWImage from 'resources/WindCreekWGray.svg';
import PostPicture from '../PostPicture';
import './DrawingFinished.css';

class DrawingFinished extends Component {
  render() {
    const {
      post,
      user,
      showLegacyFeed,
      toggleComments,
      onUnpinWallPost,
      onPinWallPost,
      onLikePost,
      onUnlikePost,
      onDeletePost,
      onLockWallPost,
      onUnlockWallPost
    } = this.props;

    const json = JSON.parse(post.message);
    const { name: drawingName, start, winners } = json;

    const startDate = moment(fromIso9075DateString(start));
    const timeString = startDate
      .format(startDate.minutes() ? 'h:mm A' : 'h A')
      .replace(' ', '\u00A0');
    const className = showLegacyFeed
      ? 'legacy-feed-drawing-finished'
      : 'feed-drawing-finished';

    return (
      <div className={className}>
        <div className="feed-message-specifics">
          <ProfileIcon src={WindCreekWImage} size={30} />
          <div className="feed-message-author-container">
            <strong>A Drawing has finished!</strong>
            <div className="post-time">
              <TimeSince
                date={fromIso9075DateString(post.created)}
                prefix="posted"
              />
            </div>
          </div>
        </div>

        <div className="drawing-finished-container">
          <PostPicture
            date={fromIso9075DateString(post.created)}
            alt="A Drawing has finished"
          />
          <div className="drawing-finished-message">
            <span className="drawing-finished-title">{drawingName}</span>
            {winners && winners.length === 1 && (
              <div className="drawing-finished-message-winner">
                Congratulations to
                <span className="drawing-finished-name"> {winners[0]}</span> on
                winning our {timeString} Drawing! Your prize has been added to
                your account.
              </div>
            )}
            {winners && winners.length > 1 && winners.length < 6 && (
              <div className="drawing-finished-message-winner">
                Congratulations to
                {winners.map((name, index) => {
                  let delimiter;
                  switch (index) {
                    case winners.length - 1:
                      delimiter = '';
                      break;
                    case winners.length - 2:
                      delimiter = ' and';
                      break;
                    default:
                      delimiter = ',';
                      break;
                  }
                  return (
                    <React.Fragment key={index}>
                      <span className="drawing-finished-name"> {name}</span>
                      {delimiter}
                    </React.Fragment>
                  );
                })}{' '}
                on winning our {timeString} Drawing! Your prizes have been added
                to your accounts.
              </div>
            )}
            {winners && winners.length >= 6 && (
              <>
                <div className="drawing-finished-message-winner">
                  Congratulations to the winners of our {timeString} Drawing!
                  Your prizes have been added to your accounts.
                </div>

                <div className="drawing-finished-winners">
                  <DataPopover
                    tooltipMessage={<WinnersTooptip entries={winners} />}
                    tooltipClass="drawing-finished-winners-tooltip"
                    trigger="click"
                    rootClose
                    container={this}
                  >
                    <WinnersButton />
                  </DataPopover>
                </div>
              </>
            )}
          </div>
        </div>
        <PostActions
          post={post}
          user={user}
          toggleComments={toggleComments}
          onUnpinWallPost={onUnpinWallPost}
          onPinWallPost={onPinWallPost}
          onLikePost={onLikePost}
          onUnlikePost={onUnlikePost}
          onDeletePost={onDeletePost}
          onLockWallPost={onLockWallPost}
          onUnlockWallPost={onUnlockWallPost}
          showLegacyFeed={showLegacyFeed}
        />
      </div>
    );
  }
}

DrawingFinished.propTypes = {
  user: userShape,
  post: wallPostShape,
  showLegacyFeed: PropTypes.bool,
  onDeletePost: PropTypes.func,
  toggleComments: PropTypes.func,
  onLikePost: PropTypes.func,
  onUnlikePost: PropTypes.func,
  onPinWallPost: PropTypes.func,
  onUnpinWallPost: PropTypes.func
};

export default DrawingFinished;

function WinnersButton(props) {
  return (
    <button
      className="btn button-color-green drawing-finished-button"
      value="View Winners"
      type="button"
      {...props}
    />
  );
}

function WinnersTooptip({ entries }) {
  const maxCols = 4;
  let numOfCols = Math.ceil(Math.sqrt(entries.length / 2));
  let numOfRows = Math.ceil(numOfCols * 2);
  if (numOfCols > maxCols) {
    numOfCols = maxCols;
    numOfRows = Math.ceil(entries.length / numOfCols);
  }
  return (
    <table className="tooltip-table">
      <tbody>
        {range(numOfRows).map(rowIdx => {
          return (
            <tr key={rowIdx}>
              {range(numOfCols).map(colIdx => {
                const entry = entries[numOfRows * colIdx + rowIdx];
                return entry && <td key={entry}>{entry}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
